/**
 * The stream's software sprites that are not bubbles - fire drops, bolts, bubble food - as the C64's
 * entity pass (D_0CF2) meets them: in one loop with the bubbles, slot 17 first, each by its type's
 * routine (the jump tables at $0D68 and $0D78).
 */

import { boltStep } from './bolts';
import { foodItems, foodStep } from './bonus';
import { dropStep } from './fire';
import { systemOf } from './system';
import type { World } from '../types';

export interface SpecialStep {
  slot: number;
  step: () => void;
}

/** This pass's drops, bolts and foods, highest slot first. */
export function specialSteps(world: World): SpecialStep[] {
  const sys = systemOf(world);
  const out: SpecialStep[] = [
    ...sys.drops.map((d) => ({ slot: d.slot, step: () => dropStep(world, d) })),
    ...sys.bolts.map((b) => ({ slot: b.slot, step: () => boltStep(world, b) })),
    ...foodItems(world).map((f) => ({ slot: f.fall.slot, step: () => foodStep(world, f) })),
  ];
  return out.sort((a, b) => b.slot - a.slot);
}
